import {
  BaseRequiredDialogProps,
  CanopyProvider,
  DialogDraggable,
} from '@bloomfieldrobotics/canopy';
import { DialogContent } from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import {
  selectCurrBlockID,
  selectCurrCustomerID,
  selectCurrPointId,
  selectCurrRanchID,
  selectCurrScanID,
} from '../../select/selectSlice';
import DebugInfo from '../DebugInfo';
const DebugInfoDialog = ({
  open: isOpen,
  onClose,
}: BaseRequiredDialogProps) => {
  const { t } = useTranslation();

  const customerID = useAppSelector(selectCurrCustomerID);
  const ranchID = useAppSelector(selectCurrRanchID);
  const blockID = useAppSelector(selectCurrBlockID);
  const scanID = useAppSelector(selectCurrScanID);
  const pointID = useAppSelector(selectCurrPointId);

  return (
    <DialogDraggable title={t('Debug Info')} open={isOpen} onClose={onClose}>
      <CanopyProvider>
        <DialogContent>
          <DebugInfo
            customerID={customerID}
            ranchID={ranchID}
            blockID={blockID}
            scanID={scanID}
            pointID={pointID}
          />
        </DialogContent>
      </CanopyProvider>
    </DialogDraggable>
  );
};

export default DebugInfoDialog;
